// Maps the promo tools `assetsTabs` list (title / value / completed) onto the
// shape the affiliate portal rail and home grid render: a kit icon name and a
// boolean "completed" flag. The icon names below are the agreed set and all
// exist in the kit's ICON_PATHS map.
export const SECTION_ICONS = {
  links: 'link',
  recruitmentLinks: 'users',
  stats: 'chart',
  swipes: 'edit',
  blogReviews: 'heading',
  allArticles: 'list-ul',
  banners: 'image',
  thankyouPageAds: 'check',
  logoutPageAds: 'logout',
  socialMediaPosts: 'share',
  videoReviews: 'play',
  facebookAds: 'star',
  signatures: 'edit',
};

export const FALLBACK_SECTION_ICON = 'ellipsis';

// Sections whose "mark as done" flag lives on the affiliate resource. `links`
// and `stats` are never completable — they are reference views, not work.
const COMPLETED_KEYS = {
  swipes: 'swipes_completed',
  blogReviews: 'blog_reviews_completed',
  allArticles: 'press_releases_completed',
  banners: 'banners_completed',
  thankyouPageAds: 'thankyou_page_ads_completed',
  logoutPageAds: 'logout_page_ads_completed',
  socialMediaPosts: 'social_media_posts_completed',
  videoReviews: 'video_reviews_completed',
  facebookAds: 'facebook_ads_completed',
  signatures: 'signatures_completed',
};

function isCompleted(tab, affiliateResource) {
  const key = COMPLETED_KEYS[tab.value];

  if (!key) {
    return false;
  }

  if (affiliateResource && typeof affiliateResource[key] !== 'undefined') {
    return Boolean(affiliateResource[key]);
  }

  return Boolean(tab.completed);
}

export function portalSections(assetsTabs, funnelResource) {
  if (!Array.isArray(assetsTabs)) {
    return [];
  }

  const affiliateResource = funnelResource ? funnelResource.affiliate_resource : null;

  return assetsTabs.map(tab => ({
    value: tab.value,
    label: tab.title,
    icon: SECTION_ICONS[tab.value] || FALLBACK_SECTION_ICON,
    completed: isCompleted(tab, affiliateResource),
  }));
}

// Stable identity for one of `funnel_resource.display_links`. The payload does
// not guarantee an id, so fall back to the position in the list.
export function affiliateLinkId(link, index) {
  if (!link) {
    return null;
  }

  return typeof link.id !== 'undefined' && link.id !== null ? link.id : `link-${index}`;
}

export default portalSections;
